module.exports = __webpack_public_path__ + "img/Illustration-email.89f624ee.png";